import { PointObjectInfo, UserObjectInfo } from "../Interface/user.interface";

const useUserInfo = () => {
    const setUseInfo = (data: UserObjectInfo) => {
        localStorage.setItem("userInfo", JSON.stringify(data));
    };
    const getUserInfo = (): UserObjectInfo => {
        const rawData = localStorage.getItem("userInfo");
        const data = rawData && JSON.parse(rawData);
        return {
            userId: data?.userId,
            fullName: data?.fullName,
            point: data?.point,
        };
    };

    const getPointDetail = (): PointObjectInfo => {
        const rawData = localStorage.getItem("pointInfo");
        const data = rawData && JSON.parse(rawData);
        return {
            totalPoints: data.totalPoint,
            expireDate: data.expireDate,
        };
    };

    return {
        getUserInfo,
        setUseInfo,
        getPointDetail,
    };
};
export default useUserInfo;
